// 公用云文档表单地址
const CLOUD_DOC_URL = 'https://f.kdocs.cn/g/';

// 云文档表单 code 全局注册表（按业务语义命名，便于同页多按钮扩展）
export const CLOUD_DOC_CODE = {
  // K12人工智能教学 - 立即咨询
  K12_CONSULT: 'SFg1JZaa',
  // 高等人才培养 - 立即咨询
  COLLEGE_CONSULT: 'ei6PhuRV',
};

// 获取云文档表单地址
export const getCloudDocUrl = (docId) => {
  const docCode = CLOUD_DOC_CODE[docId] || docId;
  return docCode ? `${CLOUD_DOC_URL}${docCode}/` : '';
};

// 通用链接解析器：支持云文档、外链、站内路由等扩展场景
export const resolveLink = (linkConfig) => {
  if (!linkConfig) return '';
  if (typeof linkConfig === 'string') return linkConfig;

  switch (linkConfig.type) {
    case 'cloudDoc':
      return getCloudDocUrl(linkConfig.code);
    case 'external':
      return linkConfig.url || '';
    case 'route':
      return linkConfig.path || '';
    default:
      return linkConfig.url || '';
  }
};
